import React, { useState, useEffect } from "react";
import WeatherIcon from "./WeatherIcon";
import "./WeatherForecastDay.css";

export default function WeatherForecastDay(props) {
  const [dayName, setDayName] = useState("");

  function maxTemperature() {
    let temperature = Math.round(props.data.temperature.maximum);
    return `${temperature}°`;
  }

  function minTemperature() {
    let temperature = Math.round(props.data.temperature.minimum);
    return `${temperature}°`;
  }

  useEffect(() => {
    function updateDayName() {
      let date = new Date(props.data.time * 1000);
      let day = date.getDay();

      let fullDays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      let shortDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      if (window.innerWidth < 768) {
        setDayName(fullDays[day]);
      } else {
        setDayName(shortDays[day]);
      }
    }
    updateDayName();
    window.addEventListener("resize", updateDayName);

    return () => {
      window.removeEventListener("resize", updateDayName);
    };
  });

  return (
    <article className="WeatherForecastDay" aria-label="Weather Forecast Day">
      <div className="weather-forecast-details">
        <div className="weather-forecast-date">{dayName}</div>
        <WeatherIcon code={props.data.condition.icon} />
        <div>
          <span className="weather-forecast-temperature-min">
            {minTemperature()}
          </span>
          <span className="weather-forecast-temperature-max">
            {maxTemperature()}
          </span>
        </div>
      </div>
    </article>
  );
}
